<template>
    <div class="news-content-container">
      <back-open-chenter />
      <div class="news-content-panel">
        <div class="news-title">1024特辑 | 我们采访了一群程序员，他们说</div>
        <div class="news-date">2024年10月24日</div>
        <div class="news-content">
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
            </div>
          </div>
          <p class="short-center">据说</p>
          <p class="short-center">世上只有两种人</p>
          <p class="short-center">一种是懂二进制的</p>
          <p class="short-center">一种是不懂二进制的</p>
          <p class="short-center">可以说</p>
          <p class="short-center">二进制计数的基本计量单位</p>
          <p class="short-center">是程序员最熟悉的数字</p> <br/>
          <p class="short-center">今天</p>
          <p class="short-center">是10月24日</p>
          <p class="short-center">我们采访了一群优图实验室的程序员们</p>
          <p class="short-center">带你了解二进制世界创造者们背后的故事</p>
          <div class="video-contain">
            <div class="youtu-video">
            <video class="player" controls="controls" poster="../img/detail/Information/news58/news58_14.png">
                <source type="video/mp4" src="/static/files/mp4file/1024V2.4.mp4">
            </video>
          </div>
          </div>
          <div class="news-content-mark">
            <div>Q1 “你怎么和亲戚解释你的职业？”</div>
          </div>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/newscenter/news58.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ qingdong</span><br/>
            “修电脑的”
          </p>
          <p>
            <span class="mark-text highlight">@ peixian</span><br/>
            “我都说我做人脸识别哈哈”
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_1.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ tyler</span><br/>
            “像什么刷脸啊这种东西他们会知道，所以他就会问，这个是什么，我说爸爸做的也是类似的工作”
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_2.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ jinlong</span><br/>
            “实现一些互联网中一些常用的一些AI的功能”
          </p>
          <p>
            <span class="mark-text highlight">@ sword</span><br/>
            “我会让他们去用一些这个ChatGPT，那我觉得这就是一个科普和这个对我现在这个工作的一个介绍吧”
          </p>
          <div class="news-content-mark">
            <div>Q2“你当初为什么选择程序员这个职业？”</div>
          </div>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_3.gif"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ peixian</span><br/>
            打游戏想写外挂，因为那个时候读书没有有没有钱去充游戏
          </p>
          <p>
            <span class="mark-text highlight">@ mingyao</span><br/>
            主要是因为比较喜欢写代码吧
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_4.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ haixin</span><br/>
            哦我也是，哈哈哈
          </p>
          <p>
            <span class="mark-text highlight">@ tyler</span><br/>
            可能更多还是感兴趣吧
          </p>
          <p>
            <span class="mark-text highlight">@ jinlong</span><br/>
            读研的时候觉得AI这个方向前景还不错
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_5.png"/>
            </div>
          </div>
          <div class="news-content-mark">
            <div>Q3“腾讯优图做程序员有什么不一样的感受？”</div>
          </div>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_6.gif"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ tyler</span><br/>
            我觉得整个腾讯优图的氛围相比其他的互联网公司，还是更加nice，更加open一点的
          </p>
          <p>
            <span class="mark-text highlight">@ kris</span><br/>
            可以很快的把我们所研究的一些技术落地
          </p>
          <p>
            <span class="mark-text highlight">@ qing</span><br/>
            这个工作比较好的一个点就是，你不需要长时间的坐在那里，就不会有什么颈椎病这种困扰
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_7.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ haixin</span><br/>
            主要东西能落地，比如刷掌啊，这个在食堂哎，你能自己感受到用到了对吧
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_8.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ sword</span><br/>
            腾讯优图传统就是两条腿走路嘛，就是学术研究和这个工业工程落地，我是准备赖在这的，我觉得优图挺好的
          </p>
          <div class="news-content-mark">
            <div>Q4“你个人认为最好的编程语言是什么？”</div>
          </div>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_9.gif"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ qingdong</span><br/>
            Python
          </p>
          <p>
            <span class="mark-text highlight">@ tyler</span><br/>
            C C++ Python这种
          </p>
          <p>
            <span class="mark-text highlight">@ sword</span><br/>
            个人最习惯用的就是Python嘛
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_10.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ jinlong</span><br/>
            我用的比较多的是Python嘛
          </p>
          <p>
            <span class="mark-text highlight">@ peixian</span><br/>
            最常用的是Python
          </p>
          <p>
            <span class="mark-text highlight">@ haixin</span><br/>
            go和C++嘛
          </p>
          <p>
            <span class="mark-text highlight">@ mingyao</span><br/>
            对我们这边主要用的是go和C++ 
          </p>
          <p>
            <span class="mark-text highlight">@ kris</span><br/>
            PHP是世界上最好的语言
          </p>
          <div class="news-content-mark">
            <div>Q5“1024，想跟自己或者程序员说的话”</div>
          </div>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_11.gif"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ qingdong</span><br/>
            祝大家1024程序员节快乐，可以快乐工作，快乐生活
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_12.png"/>
            </div>
          </div>
          <p>
            <span class="mark-text highlight">@ jinlong</span><br/>
            对自己好一点吧，然后保护好自己的头发
          </p>
          <p>
            <span class="mark-text highlight">@ kris</span><br/>
            希望大家保持自己的初心
          </p>
          <p>
            <span class="mark-text highlight">@ peixian</span><br/>
            早日退休
          </p>
          <p>
            <span class="mark-text highlight">@ qing</span><br/>
            禁止内耗
          </p>
          <p>
            <span class="mark-text highlight">@ mingyao</span><br/>
            要多运动，多锻炼身体吧，然后好好上班
          </p>
          <p>
            <span class="mark-text highlight">@ haixin</span><br/>
            还是要保持激情嘛，你做自己喜欢的事情
          </p>
          <p>
            <span class="mark-text highlight">@ sword</span><br/>
            希望我们中国的同行的一些小伙伴们能够再接再厉，好好加油，然后拿下下一个AI的诺贝尔奖
          </p>
          <p>
            <span class="mark-text highlight">@ tyler</span><br/>
            我很喜欢说的一句话，我觉得做到99%和做到99.9%是有巨大的鸿沟的，既然你选择了这个行业嘛，还是要保持热爱，保持对新技术的热爱，保持对生活的热爱
          </p>
          <div class="download-article-wrap">
            <p class="short-center"><strong>1024，你想聊聊什么</strong></p>
            <p class="short-center"><strong>欢迎留言和我们分享</strong></p>
            <p class="short-center"><strong>截至10月26日18:00</strong></p>
            <p class="short-center"><strong>我们将选出最有趣的五条评论</strong></p>
            <p class="short-center"><strong>送上鹅厂神秘礼物🎁</strong></p>
            <br/>
            <p class="short-center"><strong>大家，1024程序员节快乐🎉</strong></p>
            <p><strong></strong></p>
            <p><strong></strong></p>
            <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news58/news58_13.png"/>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
  export default {
    name: 'News58',
    components: {
      BackOpenChenter
    }
  };
  </script>
  
  <style lang="less" scoped>
  @import "./news.less";
  .news-content {
    margin: 0 auto;
    .image-panel {
      max-width: 667px;
      text-align: center;
      img {
        max-width: 667px;
      }
      span {
        font-size: 12px;
        color: #858585;
      }
    }
    .highlight {
      color: #0052FF;
    }
    .end-divide {
      width: 120px;
      height: 2px;
      margin: 20px auto;
      background: #0152d9;
    }
    .download-article-wrap {
      margin: 0 auto;
      padding: 5px 3px;
      border: 3px solid rgb(1, 82, 217);
      font-family: PingFangSC-light;
      .download-article {
        padding: 5px 10px;
        border-left: 1px solid rgb(1, 82, 217);
        border-right: 1px solid rgb(1, 82, 217);
      }
    }
    .news-literature {
      max-height: 180px;
      padding: 15px;
      overflow-y: scroll;
      background-color: #ebebeb;
    }
    .short-center{
      text-align: center;
    }
    .video-contain {
      margin: 10px auto;
      width: 440px;
    }
    .youtu-video{
      width: 440px;
      height: 515px;
      .player{
        width: 440px;
        height: 100%;
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News58.vue